/* OB Padel · shape filter chips on swipe rows + racket finder. Runs once (window.__obpd). Quick add buttons rendered
   here reuse the V6 handler ([data-cy6-add]) from ob-cycling-v6.js. */
(function () {
  if (window.__obpd) return;
  window.__obpd = true;

  function money(cents) {
    var v = cents / 100;
    var s = v % 1 === 0 ? v.toLocaleString('en-US') : v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var cur = window.obcyCur || 'AED';
    if (cur === 'AED') return '<bdi dir="ltr"><span class="po-aed" aria-hidden="true"></span><span class="obcy-vh">AED </span>' + s + '</bdi>';
    return '<bdi dir="ltr">' + cur + ' ' + s + '</bdi>';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- shape filter on swipe rows ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pd-f]');
    if (!b) return;
    var wrap = b.closest('[data-cy6-rail]'); if (!wrap) return;
    var f = b.getAttribute('data-pd-f');
    wrap.querySelectorAll('[data-pd-f]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    wrap.querySelectorAll('.cy6-pc').forEach(function (c) {
      var sh = c.getAttribute('data-shape') || '';
      c.classList.toggle('pd-off', !!f && sh !== f);
    });
    var s = wrap.querySelector('[data-cy6-swipe]');
    if (s) { s.scrollLeft = 0; s.dispatchEvent(new Event('scroll')); }
  });

  /* ---------- racket finder ---------- */
  var SH = { round: 0, teardrop: 1, hybrid: 1, diamond: 2 };
  var LV = { beginner: 0, intermediate: 1, advanced: 2 };

  function initFinder(root) {
    if (root.__obpd) return; root.__obpd = true;
    var data = [];
    try { data = JSON.parse(root.querySelector('script[data-pd-rackets]').textContent); } catch (err) { data = []; }
    var form = root.querySelector('form');
    var out = root.querySelector('[data-pd-out]');
    var prog = root.querySelectorAll('.pd-rf__prog i');
    var L = {};
    try { L = JSON.parse(root.querySelector('script[data-pd-labels]').textContent); } catch (err) { L = {}; }

    function answers() {
      var a = {};
      ['lvl', 'style', 'pain'].forEach(function (k) { var x = form.querySelector('input[name="' + k + '"]:checked'); a[k] = x ? x.value : null; });
      return a;
    }
    function updProg() {
      var a = answers(), n = 0;
      ['lvl', 'style', 'pain'].forEach(function (k) { if (a[k] != null) n++; });
      prog.forEach(function (p, i) { p.classList.toggle('on', i < n); });
    }
    function score(r, a) {
      var lvl = +a.lvl, sty = +a.style, pain = a.pain === '1';
      var t = Math.round((lvl + sty) / 2);
      if (pain) t = Math.min(t, 1) - (sty === 2 ? 0 : 1);
      if (t < 0) t = 0;
      var sh = SH[r.shape] != null ? SH[r.shape] : 1;
      var lv = LV[r.level] != null ? LV[r.level] : 1;
      var s = 100 - 28 * Math.abs(sh - t) - 18 * Math.abs(lv - lvl);
      if (pain && r.power > 80) s -= 25;
      if (pain && r.control >= 88) s += 6;
      if (sty === 2) s += r.power / 8; else if (sty === 0) s += r.control / 8; else s += (r.power + r.control) / 16;
      if (lvl === 0 && r.price > 90000) s -= 12;
      return s;
    }
    function bars(r) {
      return '<span class="pd-mt pd-mt--lg">' + esc(L.power) + '<i style="--v:' + r.power + '%;--b:#E4572E"></i>' + esc(L.control) + '<i style="--v:' + r.control + '%;--b:#2F5E93"></i></span>';
    }
    function alt(label, r) {
      if (!r) return '';
      return '<a href="' + esc(r.url) + '">' + (r.img ? '<img src="' + esc(r.img) + '" alt="" loading="lazy">' : '') + '<span>' + esc(label) + '<b>' + esc(r.title) + ' · ' + money(r.price) + '</b></span></a>';
    }
    function show() {
      var a = answers();
      if (a.lvl == null || a.style == null || a.pain == null) return;
      if (!data.length) { out.innerHTML = '<p class="pd-rf__empty">' + esc(L.empty) + '</p>'; return; }
      var list = data.map(function (r) { return { r: r, s: score(r, a) }; }).sort(function (x, y) { return y.s - x.s || x.r.price - y.r.price; });
      var best = list[0].r;
      var cheap = null, other = null;
      for (var i = 1; i < list.length; i++) { var c = list[i]; if (!cheap && c.r.price < best.price * 0.88 && c.s > list[0].s - 45) cheap = c.r; }
      var wantPower = +a.style !== 0 && a.pain !== '1';
      for (var j = 1; j < list.length; j++) {
        var o = list[j].r;
        if (o === cheap) continue;
        if (wantPower ? o.power > best.power : o.control > best.control) { other = o; break; }
      }
      var why = (L['why_' + best.shape] || '') + ' ' + (L['lvl_' + a.lvl] || '');
      var shapeName = L['shape_' + best.shape] || best.shape;
      out.classList.add('is-wait');
      setTimeout(function () {
        out.innerHTML =
          '<div class="pd-rf__im">' + (best.img ? '<img src="' + esc(best.img) + '" alt="' + esc(best.title) + '">' : '') + '</div>' +
          '<div><span class="pd-rf__m"><i></i>' + esc(L.match) + '</span>' +
          '<h3><a href="' + esc(best.url) + '">' + esc(best.title) + '</a></h3>' +
          '<p class="pd-rf__why"><b>' + esc(shapeName) + '.</b> ' + esc(why) + '</p>' + bars(best) +
          '<div class="pd-rf__buy"><b>' + money(best.price) + '</b>' + (best.compare > best.price ? '<s>' + money(best.compare) + '</s>' : '') +
          '<button class="cy6-btn" type="button" data-cy6-add data-v="' + best.v + '" data-url="' + esc(best.url) + '">' + esc(L.add) + '</button></div></div>' +
          ((cheap || other) ? '<div class="pd-rf__alt">' + alt(L.cheaper, cheap) + alt(wantPower ? L.more_power : L.more_control, other) + '</div>' : '');
        out.classList.remove('is-wait');
      }, 180);
    }
    form.addEventListener('change', function () { updProg(); var a = answers(); if (a.lvl != null && a.style != null && a.pain != null) show(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); show(); });
    updProg();
    show();
  }

  function init(scope) { (scope || document).querySelectorAll('[data-pd-finder]').forEach(initFinder); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
